import { render, staticRenderFns } from "./VersionCompareEngine.vue?vue&type=template&id=448b1955&scoped=true"
import script from "./VersionCompareEngine.vue?vue&type=script&lang=js"
export * from "./VersionCompareEngine.vue?vue&type=script&lang=js"
import style0 from "./VersionCompareEngine.vue?vue&type=style&index=0&id=448b1955&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "448b1955",
  null
  
)

export default component.exports